import { stripPathLocale } from '../../../common/localeShared';
import { TDisplayAdsProvider } from './zone';

export const SETTINGS_STICKY_EDGE_AD_PATH_PREFIXES = ['/settings'];
export const STICKY_EDGE_AD_DISPLAY_ADS_PROVIDERS: TDisplayAdsProvider[] = ['mediavine', 'aditude'];

export const doesPathMatchStickyEdgeAdPrefixes = (pathname: string, prefixes: string[]): boolean => {
  const strippedPath = stripPathLocale(pathname);

  return prefixes.some((prefix) => {
    const normalizedPrefix = prefix !== '/' && prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
    return strippedPath === normalizedPrefix || strippedPath.startsWith(`${normalizedPrefix}/`);
  });
};

export const isSettingsStickyEdgeAdPath = (pathname: string): boolean =>
  doesPathMatchStickyEdgeAdPrefixes(pathname, SETTINGS_STICKY_EDGE_AD_PATH_PREFIXES);
